export default {
  sentiment: 'Sentimiento',
  medias: 'Medios',
};
